import Controller from "./fleet.controller";
import template from "./fleet.html";

const fleet = {
  template,
  controller: Controller,
};

export default fleet;



// WEBPACK FOOTER //
// ./src/pages/fleet/fleet.component.js